'use client'

import React from 'react'
import { MailError } from '@/components/templates/mail-error'
import { Header } from '../components/layouts/Header'
import { Footer } from '../components/layouts/Footer'

export default function ErrorPage({
  error
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  React.useEffect(() => {
    console.error(error)
  }, [error])

  // ルートのエラーバウンダリは (default) レイアウトの外で描画されるため、
  // not-found.tsx と同じく Header / Footer をここで付ける
  return (
    <>
      <Header path="" />
      <MailError />
      <Footer />
    </>
  )
}
